import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { FiSend, FiTrendingUp, FiClock } from 'react-icons/fi';
import Navbar from '../../components/marketing/Navbar';
import Footer from '../../components/marketing/Footer';
import MockWindow from '../../components/marketing/MockWindow';
import heroImage from './hero.png';

const HomePage: React.FC = () => {
  useEffect(() => {
    document.title = 'Sedra Invoices — Keep money in your pocket';
  }, []);


  return (
    <div className="min-h-screen flex flex-col bg-white">
      <Navbar />

      <main id="main" className="flex-1">
        <section className="relative">
          <div className="mx-auto max-w-7xl px-6 lg:px-8 pt-16 lg:pt-24 pb-16">
            <div className="grid grid-cols-1 lg:grid-cols-[1fr_1.2fr] gap-y-12 gap-x-16 items-center">
              {/* Left: Copy */}
              <div>
                <h1 className="display-hero text-5xl sm:text-6xl font-extrabold leading-tight tracking-tight text-gray-900">
                  <span className="block">Keep money where it's supposed to be.</span>
                  <span className="block italic text-sedra-700">In your pocket.</span>
                </h1>
                <p className="mt-6 text-lg text-gray-600 max-w-prose">
                  <strong>Sedra Invoices</strong> helps small service businesses automate invoicing, get paid faster, and stay organized.
                </p>
                <div className="mt-8 flex flex-wrap gap-4">
                  <Link
                    to="/register"
                    className="inline-flex items-center justify-center rounded-xl px-6 py-3 text-base font-semibold text-white bg-sedra hover:bg-sedra-700 focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-sedra transition-colors"
                  >
                    Create your free account
                  </Link>
                  <a
                    href="#video"
                    className="inline-flex items-center justify-center rounded-xl px-6 py-3 text-base font-semibold border border-sedra text-sedra hover:bg-sedra/5 focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-sedra transition-colors"
                  >
                    Watch a 60-sec
                  </a>
                </div>
              </div>

              {/* Right: Mock window + background blob */}
              <div className="relative lg:-mr-10 xl:-mr-16 2xl:-mr-24">
                <div aria-hidden className="pointer-events-none absolute -right-12 -top-12 h-[36rem] w-[36rem] xl:h-[42rem] xl:w-[42rem] rounded-full bg-sedra/10 blur-3xl" />
                <div className="relative z-10">
                  {/* TODO: drop a real screenshot at public/marketing/hero.png.
                      MockWindow will gracefully fall back to skeleton if it’s missing. */}
                  <MockWindow imageSrc={heroImage} />
                </div>
              </div>
            </div>

            {/* Benefits row */}
            <section className="mt-10 lg:mt-14">
              <ul className="grid grid-cols-1 sm:grid-cols-3 gap-4">
                {[
                  { icon: FiSend, label: 'Send invoices' },
                  { icon: FiTrendingUp, label: 'Track payments' },
                  { icon: FiClock, label: 'Save time' }
                ].map(({ icon: Icon, label }) => (
                  <li key={label} className="flex items-center gap-3 rounded-xl border border-gray-200 bg-white/70 backdrop-blur px-4 py-3">
                    <Icon aria-hidden className="h-5 w-5 text-sedra" />
                    <span className="text-sm font-medium text-gray-700">{label}</span>
                  </li>
                ))}
              </ul>
            </section>
          </div>
        </section>

        {/* Placeholder anchors so nav links resolve */}
        <section id="features" className="sr-only" aria-hidden="true" />
        <section id="pricing" className="sr-only" aria-hidden="true" />
      </main>

      <div className="mt-24" />
      <Footer />
    </div>
  );
};

export default HomePage; 